<script setup lang="ts">
import {
	RadioGroupRoot,
	useForwardPropsEmits,
	type RadioGroupRootEmits,
	type RadioGroupRootProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends RadioGroupRootProps, ClassProps {}

const props = defineProps<Props>();
const emit = defineEmits<RadioGroupRootEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<RadioGroupRoot :class="cn('grid gap-3', props.class)" v-bind="forwarded">
		<slot />
	</RadioGroupRoot>
</template>
